import React from 'react';
import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'

// 🔍 Sentry Error Tracking - Inicializar ANTES de tudo
import { initSentry, isSentryEnabled } from './lib/sentry';
initSentry();

console.log('[Main] Starting application...');
console.log('[Main] Environment:', {
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV,
  prod: import.meta.env.PROD,
  baseUrl: import.meta.env.BASE_URL,
  sentryEnabled: isSentryEnabled()
});

// Global error handler with detailed logging
window.addEventListener('error', (event) => {
  console.error('[Main] Global error:', {
    message: event.message,
    filename: event.filename,
    lineno: event.lineno,
    colno: event.colno,
    error: event.error,
    stack: event.error?.stack
  });
});

window.addEventListener('unhandledrejection', (event) => {
  console.error('[Main] Unhandled promise rejection:', {
    reason: event.reason,
    promise: event.promise
  });
});

try {
  const rootElement = document.getElementById("root");
  if (!rootElement) {
    throw new Error('Root element not found');
  }
  
  console.log('[Main] Root element found, creating React root...');
  const root = createRoot(rootElement);
  
  console.log('[Main] Rendering App component...');
  root.render(React.createElement(App));
  
  console.log('[Main] App rendered successfully');
} catch (error) {
  console.error('[Main] Error during app initialization:', error);
  
  // Safe Fallback UI sem innerHTML
  const rootElement = document.getElementById("root");
  if (rootElement) {
    rootElement.replaceChildren(); // Limpa com segurança

    const container = document.createElement("div");
    container.style.cssText = "min-height: 100vh; display: flex; align-items: center; justify-content: center; background-color: #f0f0f0; font-family: system-ui, sans-serif; text-align: center; padding: 2rem;";

    const card = document.createElement("div");

    const title = document.createElement("h1");
    title.style.cssText = "font-size: 2rem; margin-bottom: 1rem; color: #333;";
    title.textContent = "⚠️ Erro ao carregar aplicação";

    const desc = document.createElement("p");
    desc.style.cssText = "color: #666; margin-bottom: 2rem;";
    desc.textContent = "Ocorreu um erro durante a inicialização. Verifique o console para mais detalhes.";

    const btn = document.createElement("button");
    btn.style.cssText = "padding: 0.5rem 1rem; background-color: #2196f3; color: white; border: none; border-radius: 4px; cursor: pointer;";
    btn.textContent = "Recarregar Página";
    btn.onclick = () => window.location.reload();

    card.appendChild(title);
    card.appendChild(desc);
    card.appendChild(btn);
    container.appendChild(card);
    rootElement.appendChild(container);
  }
}
